import MyPointsService from "../shared/services/my-points-service"
var lastPromise = null
export function requestExpiredPoints() {
  
  if (lastPromise) {
    return lastPromise
  }
  lastPromise = new Promise(resolve => {
    if (!localStorage.hasOwnProperty("TOKEN_INFO")) {
      return 0
    }
    try {
      let tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken
      var config = {
        headers: {
          Authorization: tokenId,
        },
      }

      MyPointsService.getExpiredPoints("2020-01-01", "2022-12-31", config).then(
        response => {
          if (response.status !== 200) {
            resolve(0)
            return
          }

          let toExpired = response.data?.pointsToExpire || 0
          resolve(toExpired)
        }
      )
    } catch (error) {
      resolve(0)
    }
  })
  return lastPromise
}
